/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';

import { Home } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { getList, getLOBPushNotification } from './operations';
import ViewFormContent from './ViewFormContent';
import { Breadcrumbs, SubHeader, Footer } from '../../../components';
import './styles.scoped.css';

const utc = require('dayjs/plugin/utc');

dayjs.extend(utc);

const viewLOBPushNotifications = () => {
  const navigate = useNavigate();
  const user = useSelector(state => state.admin?.user);
  const { id } = useParams();
  const [lobs, setLOBs] = useState([]);
  const [recipientStatuses, setRecipientStatuses] = useState([]);
  const [messageCharCount, setMessageCharCount] = useState(0);
  const messageCharLimit = 150;
  const [subjectCharCount, setSubjectCharCount] = useState(0);
  const subjectCharLimit = 50;
  const [isLoadingLobs, setIsLoadingLOBs] = useState(false);
  const [isLoadingRecipientStatus, setIsLoadingRecipientStatus] = useState(false);
  const [form, setForm] = useState({});

  const handleGetRecipientStatuses = async () => {
    setIsLoadingRecipientStatus(true);
    try {
      const responses = await getList('driver-status');
      setRecipientStatuses(responses);
    } catch (e) {
      console.log('e');
    }
    setIsLoadingRecipientStatus(false);
  };

  const handleGetLOB = async () => {
    setIsLoadingLOBs(true);
    try {
      const responses = await getList('line-of-business');
      setLOBs(responses);
    } catch (e) {
      console.log('e', e);
    }
    setIsLoadingLOBs(false);
  };

  const customStyles = width => ({
    control: provided => ({
      ...provided,
      width: width,
      height: '30px',
      minWidth: '300px',
    }),
    menuList: provided => ({
      ...provided,
      maxHeight: '200px',
    }),
    menu: provided => ({
      ...provided,
      zIndex: 100000,
    }),
  });

  const getNotification = async anId => {
    try {
      const response = await getLOBPushNotification(anId);
      setForm({
        ...form,
        id: response?.id,
        type: response?.type,
        subject: response?.subject,
        message: response?.message,
        url: response?.url,
        status: response?.status,
        lob: response?.lob,
        branch: response?.branch,
        recipientStatus: response?.recipientStatus,
        approvedBy: response?.name,
        approvedAt: response?.approvedAt,
        sentOn: response?.sentOn,
        createdBy: response?.createdBy,
        createdAt: response?.createdAt,
      });
    } catch (e) {
      console.log('e', e);
    }
  };

  const handleCancel = () => {
    setForm({});
    navigate(-1);
  };

  const convertArrayToObject = items => {
    const arr = [];
    if (items) {
      items.split(', ').forEach(i => arr.push({ label: i, value: i }));
    }
    return arr;
  };

  const handleCheckbox = e => {
    if (e.target.checked === true) {
      setForm({
        ...form,
        status: 'Sent',
        sentOn: dayjs().utc().format(),
        approvedBy: user.name,
        approvedAt: dayjs().utc().format(),
      });
    }
    if (e.target.checked !== true) {
      setForm({
        ...form,
        status: 'Pending',
      });
    }
  };

  useEffect(() => {
    if (form?.subject || form?.message) {
      setSubjectCharCount(form?.subject.trim().length);
      setMessageCharCount(form?.message.trim().length);
    }
  }, [form?.subject, form?.message]);

  useEffect(() => {
    if (id) {
      getNotification(id);
    }
  }, [id]);

  useEffect(() => {
    handleGetLOB();
    handleGetRecipientStatuses();
  }, []);

  return (
    <>
      <SubHeader
        text="Push Notifications"
        buttons={[
          { icon: <Home sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/push-notifications') },
        ]}
      />

      <Breadcrumbs
        wrapStyle={{ margin: 0 }}
        leftTitle="PN Home"
        middleTitle="LOB Push Notifications"
        midItemAction={() => navigate(`../push-notifications/lob-push-notifications`, { replace: true })}
        rightTitle={`${location.pathname.includes('edit') ? 'Edit LOB Notification' : 'View LOB Notification'}`}
        route="/push-notifications/lob-push-notifications"
        style={{ marginLeft: 30 }}
      />

      <ViewFormContent
        customStyles={customStyles}
        lobs={lobs}
        headerTitle={`${'View LOB Push Notification'}`}
        handleCheckbox={handleCheckbox}
        recipientStatuses={recipientStatuses}
        form={form}
        handleCancel={handleCancel}
        messageCharCount={messageCharCount}
        messageCharLimit={messageCharLimit}
        subjectCharCount={subjectCharCount}
        subjectCharLimit={subjectCharLimit}
        convertArrayToObject={convertArrayToObject}
        isLoadingRecipientStatus={isLoadingRecipientStatus}
        isLoadingLOBS={isLoadingLobs}
      />

      <Footer />
    </>
  );
};

export default viewLOBPushNotifications;
